<template>
  <shit-shell :title="title" @filter="filterShits">
    <shit-todo v-for="shit in shits" :key="shit.uuid" :shit="shit" ref="shits" @enter="insertShit" @up="focusShitAbove" @down="focusShitBelow" />
  </shit-shell>
</template>

<script>
import ShitShell from '../components/ShitShell'
import ShitTodo from '../components/ShitTodo'
import { mapActions } from 'vuex'
import shit from '../mixins/shit'

export default {
  name: 'Collect',
  mixins: [shit],
  components: {
    ShitShell,
    ShitTodo
  },
  data () {
    return {
      filter: s => true,
      compareFn: (one, two) => 0,
      title: (new Intl.DateTimeFormat(undefined, { weekday: 'long' })).format(new Date())
    }
  },
  computed: {
    shits () {
      return this.$store.state.shits.filter(this.filter).sort(this.compareFn)
    }
  },
  mounted () {
    if (!this.shits.length) {
      this.appendEmptyShit()
    }
    // this.filterShits(this.filter)
    // this.sortShits(this.compareFn)
  },
  updated () {
    this.$nextTick().then(() => {
      // restore the sorting to normal so that when we insertShit, it doesn't jump
      // this.mustSort = false
    })
  },
  methods: {
    ...mapActions(['appendEmptyShit', 'insertEmptyShitAfter']),
    filterShits (callback) {
      this.filter = callback
    },
    sortShits (compareFn) {
      this.compareFn = compareFn
    },
    insertShit (shit) {
      this.insertEmptyShitAfter(shit).then((shitBelow) => {
        const $shit = this.$refs.shits.find(s => s.shit.uuid === shitBelow.uuid)
        $shit.focus()
      })
    },
    focusShitBelow (shit) {
      const idx = this.shits.findIndex(s => shit.uuid === s.uuid)
      const nextIdx = idx + 1
      if (nextIdx === this.shits.length) {
        return
      }

      const shitBelow = this.shits[nextIdx]
      const $shit = this.$refs.shits.find(s => s.shit.uuid === shitBelow.uuid)
      $shit.focus()
    },
    focusShitAbove (shit) {
      const idx = this.shits.findIndex(s => shit.uuid === s.uuid)
      if (idx === -1) {
        return
      }

      const prevIdx = idx - 1
      if (prevIdx === -1) {
        return
      }

      const shitAbove = this.shits[prevIdx]
      const $shit = this.$refs.shits.find(s => s.shit.uuid === shitAbove.uuid)
      $shit.focus()
    }
  }
}
</script>
